import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { API_URI } from '../../environments/environment';

// Reporta errores del frontend al backend, donde quedan logueados con stack completo
// (logs/error-*.log) y disparan un email de aviso. Pensado para errores que antes solo
// mostraban "error desconocido" y no quedaban registrados en ningún lado.
@Injectable({
  providedIn: 'root'
})
export class ErrorReporteService {
  private http = inject(HttpClient);
  private readonly API = API_URI + 'app';
  private readonly APP = 'libresalud';

  // Fire-and-forget: nunca rompe el flujo que lo llama. Devuelve un ref corto para
  // poder mostrárselo al usuario y cruzarlo con el log / el email.
  reportar(contexto: string, err: any, extra?: Record<string, any>): string {
    const ref = Date.now().toString(36) + Math.random().toString(36).slice(2, 5);

    let detalle = '';
    try {
      detalle = JSON.stringify(err, Object.getOwnPropertyNames(err ?? {}));
    } catch { /* objeto no serializable, se ignora */ }

    const payload = {
      ref,
      contexto,
      app: this.APP,
      plataforma: this.detectarPlataforma(),
      perfil: extra?.['perfil'] ?? null,
      email: extra?.['email'] ?? null,
      mensaje: err?.message ?? (typeof err === 'string' ? err : null),
      code: err?.code ?? err?.error?.code ?? err?.error?.error?.message ?? null,
      // Si es un error de una llamada HTTP (ej. la API externa de validación de socio)
      httpStatus: (err?.status === 0 || err?.status) ? err.status : null,
      httpUrl: err?.url ?? null,
      stack: err?.stack ?? null,
      detalle: detalle || null,
      url: typeof location !== 'undefined' ? location.href : null,
    };

    this.http.post(`${this.API}/errores/registrar`, payload)
      .pipe(catchError(() => of(null)))
      .subscribe();

    return ref;
  }

  // android | ios | pwa (instalada en pantalla de inicio) | web (navegador) | desconocida
  private detectarPlataforma(): string {
    try {
      const p = Capacitor.getPlatform();
      if (p === 'android' || p === 'ios') return p;
      const standalone =
        (typeof window !== 'undefined' && !!window.matchMedia?.('(display-mode: standalone)')?.matches) ||
        (typeof navigator !== 'undefined' && (navigator as any).standalone === true);
      return standalone ? 'pwa' : 'web';
    } catch {
      return 'desconocida';
    }
  }
}
